import { Badge, Table } from "react-bootstrap";

const QueryWorkloadTable = () => {
  const queryWorkloadData = [
    {
      user: "M. Patil",
      role: "CRC",
      site: "Site 02",
      assigned: 276,
      open: 52,
      overdue: 29,
      created: 0,
      answered: 252,
      closed: 0,
      avgTat: "8.7 d",
      sla: 89,
    },
    {
      user: "N. Gupta",
      role: "Data Manager",
      site: "—",
      assigned: 34,
      open: 34,
      overdue: 20,
      created: 124,
      answered: 0,
      closed: 163,
      avgTat: "3.6 d",
      sla: 41,
    },
    {
      user: "R. Sharma",
      role: "CRA",
      site: "—",
      assigned: 33,
      open: 33,
      overdue: 26,
      created: 108,
      answered: 0,
      closed: 147,
      avgTat: "3.9 d",
      sla: 21,
    },
    {
      user: "T. Fernandes",
      role: "Data Manager",
      site: "—",
      assigned: 22,
      open: 22,
      overdue: 16,
      created: 116,
      answered: 0,
      closed: 144,
      avgTat: "4.2 d",
      sla: 27,
    },
    {
      user: "A. Joshi",
      role: "CRC",
      site: "—",
      assigned: 126,
      open: 17,
      overdue: 7,
      created: 0,
      answered: 115,
      closed: 0,
      avgTat: "4.5 d",
      sla: 94,
    },
  ];
  return (
    <div className="table-responsive">
      <Table className="m-0 custom-table" hover striped>
        <thead className="position-sticky top-0 z-1">
          <tr>
            <th>USER</th>
            <th>ROLE</th>
            <th>SITE</th>
            <th>ASSIGNED</th>
            <th>OPEN</th>
            <th>OVERDUE</th>
            <th>CREATED</th>
            <th>ANSWERED</th>
            <th>CLOSED</th>
            <th>AVG TAT</th>
            <th>SLA</th>
          </tr>
        </thead>

        <tbody>
          {queryWorkloadData?.map((item, index) => (
            <tr key={index}>
              <td className="fw-semibold">{item.user}</td>
              <td>{item.role}</td>
              <td>{item.site}</td>
              <td>{item.assigned}</td>
              <td>{item.open}</td>

              <td className="text-danger fw-semibold">{item.overdue}</td>

              <td>{item.created}</td>
              <td>{item.answered}</td>
              <td>{item.closed}</td>
              <td>{item.avgTat}</td>

              <td>
                <Badge bg={item.sla >= 85 ? "success" : "danger"} pill>
                  {item.sla}%
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default QueryWorkloadTable;
